export default __webpack_public_path__ + "static/media/img_features02.41c1a0bd.png";